import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Result, Layout } from 'antd';
import { CheckCircleOutlined, PlusOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import AppHeader from '../components/Header';
import authService from '../services/authService';
import { getSiteVisitFormsById } from '../services/apiService';
import FullPageLoader from '../components/FullPageLoader';

const { Content } = Layout;

const ThankYou = () => {
  const navigate = useNavigate();
  const { companyId, formId } = useParams();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch form data for logo
  useEffect(() => {
    const fetchFormData = async () => {
      try {
        const data = await getSiteVisitFormsById(companyId, formId);
        setFormData(data);
      } catch (error) {
        console.error('Failed to fetch form data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (companyId && formId) {
      fetchFormData();
    }
  }, [companyId, formId]);

  // Handle responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmitNewLead = () => {
    navigate(`/companies/${companyId}/site_visit_forms/${formId}/view`);
  };

  const handleBackToForms = () => {
    navigate(`/companies/${companyId}/site_visit_forms/list`);
  };

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
    setDrawerVisible(false);
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile',
      onClick: () => navigate('/')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
      danger: true
    }
  ];

  const formMeta = formData?.meta || {};


  if (loading) {
    return <FullPageLoader />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader 
        isMobile={isMobile}
        formMeta={formMeta}
        userMenuItems={userMenuItems}
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        handleLogout={handleLogout}
      />
      
      <Content style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#f0f2f5',
        padding: isMobile ? 12 : 24
      }}>
        <Card style={{ maxWidth: 600, width: '100%', textAlign: 'center' }}>
          <Result
            icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
            status="success"
            title="Form Submitted Successfully!"
            subTitle="Thank you for submitting the site visit form. Your information has been recorded."
            extra={[
              <Button 
                type="primary" 
                size="large"
                icon={<PlusOutlined />}
                onClick={handleSubmitNewLead}
                style={{ background: '#5568d3', marginRight: 8 }}
                key="submit-new"
              >
                Submit New Lead
              </Button>,
              <Button 
                size="large"
                onClick={handleBackToForms}
                key="back"
              >
                Back to Forms
              </Button>
            ]}
          />
        </Card>
      </Content>
    </Layout>
  );
};

export default ThankYou;
